import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { NutritionCodeEnum } from 'Common/Constants/Enumeration/NutritionCodeEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import * as servingMenuItemsActions from 'PointOfSale/modules/servingOptions/state/actions';
import * as setDateAndSetActions from 'PointOfSale/modules/setDateAndSite/state/action';
import ServingOptionFooterComponent from 'PointOfSale/modules/layouts/component/ServingOptionFooter';
import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';
import { AUTO_SERVE_OPTIONS } from 'PointOfSale/modules/common/constants';
import { SessionTypes } from 'PointOfSale/modules/common/constants';
import * as TeacherActions from 'PointOfSale/modules/teacher/state/actions';
import * as POSSelectors from 'PointOfSale/selectors';

class ServingOptionFooter extends Component {
  state = {
    showDialog: false,
  };
  validateForm = () => {
    const {
      currentSelectedMenu,
      selectedSiteDetails,
      currentSession,
      cepType,
    } = this.props;

    const isCepOn =
      selectedSiteDetails &&
      selectedSiteDetails.AlternateProvisionTypeId ===
        AlternateProvisionTypeEnum.CEP;

    if (_.isEmpty(currentSession)) {
      createToast(
        toastType.error,
        'Error',
        'Please select a serving type',
        true
      );
      return false;
    }
    if (!currentSession.type) {
      createToast(
        toastType.error,
        'Error',
        'Please select a serving type',
        true
      );
      return false;
    }

    if (isCepOn && _.isEmpty(cepType) && currentSession.autoServe) {
      createToast(
        toastType.error,
        'Error',
        'Please select an auto serve type',
        true
      );
      return false;
    }

    if (
      currentSession.quickServeItem &&
      currentSession.quickServeSelectedItem === ''
    ) {
      createToast(
        toastType.error,
        'Error',
        'Please select a quick serve item',
        true
      );
      return false;
    }

    /** Check for NutritionCode '1' if CEP and MealCounter */
    if (
      isCepOn &&
      cepType.Id === AUTO_SERVE_OPTIONS.MealCounter &&
      cepType.selected &&
      currentSession.autoServe
    ) {
      if (
        _.get(currentSession, 'quickServeSelectedItem.NutritionCode') !==
        NutritionCodeEnum.FederalType1Meal
      ) {
        createToast(
          toastType.error,
          'Error',
          'Quick serve item is not a valid CEP item',
          true
        );
        return false;
      }
    }

    if (!currentSelectedMenu) {
      createToast(toastType.error, 'Error', 'Please select a menu', true);
      return false;
    }

    if (currentSession.type === SessionTypes.Teacher) {
      if (!currentSession.quickServeItem) {
        this.setState({ showDialog: true });
        return false;
      }
    }

    return true;
  };

  handleOnClick = () => {
    const {
      selectedSiteDetails,
      setDateAndSetActions,
      location,
      history,
      currentSession,
    } = this.props;

    if (_.isEmpty(selectedSiteDetails)) {
      setDateAndSetActions.setSiteDatePopupOpen();
      return;
    }

    if (this.validateForm()) {
      if (currentSession.type === SessionTypes.Teacher) {
        TeacherActions.reset();
        if (
          currentSession.quickServeItem &&
          !currentSession.quickServeSelectedItem
        ) {
          this.setState({ showDialog: true });
        } else {
          setDateAndSetActions.setSiteAndDate({}, location.pathname, history);
        }
      } else {
        setDateAndSetActions.setSiteAndDate({}, location.pathname, history);
      }
    }
  };

  handleDialogTeacherQSI(answer) {
    const { setDateAndSetActions, location, history } = this.props;
    this.setState({ showDialog: false });
    if (answer) {
      setDateAndSetActions.setSiteAndDate({}, location.pathname, history);
      TeacherActions.reset();
    }
  }

  render() {
    const { showDialog } = this.state;
    return (
      <React.Fragment>
        <YesNoDialog
          showDialog={showDialog}
          title="Confirm"
          question="Are you sure you want to continue without a quick serve item selected?"
          yesCallback={() => {
            this.handleDialogTeacherQSI(true);
          }}
          noCallback={() => {
            this.handleDialogTeacherQSI(false);
          }}
        />
        <ServingOptionFooterComponent handleOnClick={this.handleOnClick} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  currentSelectedMenu: POSSelectors.getCurrentSelectedMenu(state),
  currentSession: POSSelectors.getCurrentSession(state),
  cepType: POSSelectors.getSelectedCepType(state),
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
});

const mapDispatchToProps = dispatch => ({
  servingMenuItemsActions: bindActionCreators(
    servingMenuItemsActions,
    dispatch
  ),
  setDateAndSetActions: bindActionCreators(setDateAndSetActions, dispatch),
  TeacherActions: bindActionCreators(TeacherActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ServingOptionFooter)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/ServingOptionFooter.js